/**
 * User roles inside a workshop. Must match the `workshop_role` enum in
 * supabase/migrations. Texts: `role.<role>.label` and `role.<role>.description`.
 */
export const ROLES = ["owner", "manager", "office", "mechanic"] as const;
export type Role = (typeof ROLES)[number];

export function isRole(value: string): value is Role {
  return (ROLES as readonly string[]).includes(value);
}

export const MIN_PASSWORD_LENGTH = 8;
